import { Routes, Route } from "react-router-dom";
import { PublicLayout } from "./layouts/PublicLayout";
import { AdminLayout } from "./layouts/AdminLayout";
import { AdminRoute } from "./components/AdminRoute";

// Public Pages
import { HomePage } from "./pages/public/HomePage";
import { ArticlePage } from "./pages/public/ArticlePage";
import { ListingPage } from "./pages/public/ListingPage";
import { SearchPage } from "./pages/public/SearchPage";
import { StaticPage } from "./pages/public/StaticPage";
import { CategoryShortcutPage } from "./pages/public/CategoryShortcutPage";
import { NotFoundPage } from "./pages/public/NotFoundPage";

// Admin Pages
import { LoginPage } from "./pages/admin/LoginPage";
import { DashboardPage } from "./pages/admin/DashboardPage";
import { ArticlesPage } from "./pages/admin/ArticlesPage";
import { ArticleEditorPage } from "./pages/admin/ArticleEditorPage";
import { HomepageCurationPage } from "./pages/admin/HomepageCurationPage";
import { MediaPage } from "./pages/admin/MediaPage";
import { TaxonomyPage } from "./pages/admin/TaxonomyPage";
import { AdvertisingPage } from "./pages/admin/AdvertisingPage";
import { CommentsPage } from "./pages/admin/CommentsPage";
import { NewsletterPage } from "./pages/admin/NewsletterPage";
import { AnalyticsPage } from "./pages/admin/AnalyticsPage";
import { UsersPage } from "./pages/admin/UsersPage";
import { SystemPage } from "./pages/admin/SystemPage";
import { ArchiveSearchPage } from "./pages/admin/ArchiveSearchPage";

export function App() {
  return (
    <Routes>
      {/* Public Pages */}
      <Route path="/" element={<PublicLayout />}>
        <Route index element={<HomePage />} />
        <Route path="article/:slug" element={<ArticlePage />} />
        <Route path="category/:slug" element={<ListingPage type="category" />} />
        <Route path="author/:slug" element={<ListingPage type="author" />} />
        <Route path="tag/:slug" element={<ListingPage type="tag" />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="newsletter" element={<StaticPage slug="newsletter" />} />
        <Route path="about" element={<StaticPage slug="about" />} />
        <Route path="contact" element={<StaticPage slug="contact" />} />
        <Route path="advertise" element={<StaticPage slug="advertise" />} />
        <Route path="privacy" element={<StaticPage slug="privacy" />} />
        <Route path="terms" element={<StaticPage slug="terms" />} />
        <Route path="cookie-policy" element={<StaticPage slug="cookie-policy" />} />
        <Route path=":slug" element={<CategoryShortcutPage />} />
      </Route>

      {/* Admin Auth */}
      <Route path="/admin/login" element={<LoginPage />} />

      {/* Admin Dashboard & Management with Role-Based Access Control */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<DashboardPage />} />
        <Route
          path="articles"
          element={
            <AdminRoute permission="articles.view">
              <ArticlesPage />
            </AdminRoute>
          }
        />
        <Route
          path="articles/new"
          element={
            <AdminRoute permission="articles.manage">
              <ArticleEditorPage />
            </AdminRoute>
          }
        />
        <Route
          path="articles/:id/edit"
          element={
            <AdminRoute permission="articles.manage">
              <ArticleEditorPage />
            </AdminRoute>
          }
        />
        <Route
          path="homepage"
          element={
            <AdminRoute permission="homepage.manage">
              <HomepageCurationPage />
            </AdminRoute>
          }
        />
        <Route
          path="media"
          element={
            <AdminRoute permission="media.view">
              <MediaPage />
            </AdminRoute>
          }
        />
        <Route
          path="taxonomy"
          element={
            <AdminRoute permission="categories.manage">
              <TaxonomyPage />
            </AdminRoute>
          }
        />
        <Route
          path="advertising"
          element={
            <AdminRoute permission="advertising.manage">
              <AdvertisingPage />
            </AdminRoute>
          }
        />
        <Route
          path="comments"
          element={
            <AdminRoute permission="comments.manage">
              <CommentsPage />
            </AdminRoute>
          }
        />
        <Route
          path="newsletter"
          element={
            <AdminRoute permission="newsletter.manage">
              <NewsletterPage />
            </AdminRoute>
          }
        />
        <Route
          path="analytics"
          element={
            <AdminRoute permission="analytics.view">
              <AnalyticsPage />
            </AdminRoute>
          }
        />
        <Route
          path="users"
          element={
            <AdminRoute permission="users.manage">
              <UsersPage />
            </AdminRoute>
          }
        />
        <Route
          path="settings"
          element={
            <AdminRoute permission="settings.manage">
              <SystemPage />
            </AdminRoute>
          }
        />
        <Route
          path="search"
          element={
            <AdminRoute permission="articles.view">
              <ArchiveSearchPage />
            </AdminRoute>
          }
        />
        <Route
          path="system"
          element={
            <AdminRoute permission="settings.manage">
              <SystemPage />
            </AdminRoute>
          }
        />
      </Route>

      {/* 404 Catch-All */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
